/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Deprecated since BoM 25.26, it's now handled by CAL Payment.
 * @deprecated
 */
export enum ReceiverDisplayedValueType {
    BBAN = 'BBAN',
    IBAN = 'IBAN',
    EMAIL = 'EMAIL',
    PHONE = 'PHONE',
    TAX_ID = 'TAX_ID',
    TAX_NUMBER = 'TAX_NUMBER',
    PAN = 'PAN',
}
